import { ReactComponent as EmptyStateGraphic } from '@elementary/common-ui/assets/empty-state-cloud.svg';
import { FlexColumn, Link } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import styled from 'styled-components';

const Wrapper = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.palette.common.gray15};
  padding: 16px 24px;
  gap: 16px;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

const Text = styled(Typography)`
  text-align: center;
`;

const DependenciesEmptyState = () => (
  <Wrapper>
    <EmptyStateGraphic width="57px" />
    <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
      No assets linked to this test
    </Typography>
    <FlexColumn>
      <Text>
        Connect this test to the relevant asset to view its dependencies.
      </Text>
      <Text>
        See the{' '}
        <Link
          target="_blank"
          href={
            'https://docs.elementary-data.com/cloud/features/data-tests/data-tests-overview'
          }
        >
          docs{' '}
        </Link>
        for more info.
      </Text>
    </FlexColumn>
  </Wrapper>
);

export default DependenciesEmptyState;
